import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { IonicModule } from "@ionic/angular";
import { TabsPage } from "./tabs";
import { authGuard } from "src/guards/auth.guard";
const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      
      { path: 'tab1',  
        children: [
          { path: '', loadComponent: () => import('../event/main/event-search/event-search').then(m => m.EventSearchPage) },
          {path:'event', loadChildren:()=>import('../event/event.module').then(m=>m.EventModule)},
        ]
      },
      { path: 'tab2', 
        children:[
          {path:'', loadComponent: () => import('../me/mysport/mysport-user-profile/mysport-user-profile').then(m => m.MysportUserProfilePage)},
          {path:'me', loadChildren:()=>import('../me/me.module').then(m=>m.MeModule)},
          {path:'results', loadChildren:()=>import('../results/results.module').then(m=>m.ResultsModule)},
          {path:'notification', loadChildren:()=> import('../notification/notification.module').then(m=>m.NotificationModule)},
          { path:'text-pages',loadChildren:()=>import('../textPages/text-pages.module').then(m=>m.TextPagesModule)},
          {path:'event', loadChildren:()=>import('../event/event.module').then(m=>m.EventModule)},
        ]
      },
      { path: 'tab3',  
        children:[
          {path:'', loadComponent: () => import('../results/result-search/result-search').then(m => m.ResultSearchPage)},
          { path:'results', loadChildren:()=>import('../results/results.module').then(m=>m.ResultsModule)},
          {path:'event', loadChildren:()=>import('../event/event.module').then(m=>m.EventModule)},
          {path:'me', loadChildren:()=>import('../me/me.module').then(m=>m.MeModule)},
        ]
      },
      { path: 'tab4', 
        children:[
          {path:'', loadComponent: () => import('src/tracker/track-page/trackpage').then(m => m.TrackPage)},
          {path:'nearby', loadChildren:()=>import('../nearby/nearby.module').then(m=>m.NearbyModule)},
        ],
        canActivate: [authGuard],
        data: { postLoginTab: 4 } 
      },
      { path: 'tab5', 
        children:[
          {path:'', loadComponent: () => import('../event/event-activity-tabs/event-activity-tabs').then(m => m.EventActivityTabsPage)},
          { path:'results', loadChildren:()=>import('../results/results.module').then(m=>m.ResultsModule)},
          {path:'me', loadChildren:()=>import('../me/me.module').then(m=>m.MeModule)},
        ],
        canActivate: [authGuard],
        data: { postLoginTab: 5 } 
      },
      { path: 'tab6', loadComponent: () => import('../results/result-teams/result-teams').then(m => m.ResultTeamsPage) },
      { path: 'tab7', loadComponent: () => import('../notification/main/notification').then(m => m.NotificationPage) },
      { path: 'tab8', loadComponent: () => import('src/tracker/leader-track-page/leader-track').then(m => m.LeaderTrack) },
      { path: 'tab9', loadComponent: () => import('../apps/gamer/pages/team-list/gamer-teams').then(m => m.GamerTeamsPage) },
      { path: 'tab10', loadComponent: () => import('../apps/lineup/lineup').then(m => m.LineupPage) },
      { path: 'tab11', loadComponent: () => import('../apps/gamer/pages/new-tou/new-tou-main').then(m => m.NewTouMainPage) },
      { path: 'tab12', loadComponent: () => import('../apps/gamer/pages/results/main/plan-result-main').then(m => m.PlanResultsMainPage) },
      { path: 'tab13', loadComponent: () => import('../apps/gamer/pages/tou-list/tou-list').then(m => m.TouListPage),canActivate: [authGuard],  },
      { path: 'tab14', loadComponent: () => import('../anmeldungen-page/anmeldungen.module').then(m => m.AnmeldungenModule) },
      { path: '', redirectTo: 'tab1', pathMatch: 'full' },

      // TODO: remove all postLoginAction() from tabs.ts  and use only auth guard there 

      {path:'notification', loadChildren:()=>
        import('../notification/notification.module').then(m=>m.NotificationModule)
      },
      {path:'event', loadChildren:()=>import('../event/event.module').then(m=>m.EventModule)},
      {path:'me',
        loadChildren:()=>import('../me/me.module').then(m=>m.MeModule)
      },
      {path:'gamer',
        loadChildren:()=>import('../apps/gamer/gamer.module').then(m=>m.GamerModule)
      },
      {
        path:'results',
        loadChildren:()=>import('../results/results.module').then(m=>m.ResultsModule)
      },
      {
        path:'participant',
        loadChildren:()=>import('../participant-page/participant.module').then(m=>m.ParticipantModule)
      },
      {
        path:'lineup',
        loadChildren:()=>import('../apps/lineup/lineup.module').then(m=>m.LineupModule)
      },
      {
        path:'test-page',
        loadChildren:()=>import('../test-page/test-page.module').then(m=>m.TestPageModule)
      },
      {
        path:'in-browser',
        loadChildren:()=>import('../browser/browser.module').then(m=>m.InBrowserModule)
      },
      {
        path:'payment',
        loadChildren:()=>import('../payment-system/payment.module').then(m=>m.PaymentModule)
      },
      {
        path:'instant-paypal',
        loadChildren:()=>import('../instantpaypal/instant-paypal.module').then(m=>m.InstantPaypalModule)
      },
      {path:'tutorials', loadComponent:()=>import('../../components/tutorials/tutorials.component').then(m=>m.TutorialsComponent)}
    ]
  }
];
@NgModule({
    declarations: [
        TabsPage,
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        IonicModule,
        TranslateModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
      TabsPage
    ]
  })
  export class TabsModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }